import isDate from "lodash/isDate";
import moment from "moment";

export abstract class BaseHTMLElement extends HTMLElement {

    private _initialValue: OrginalValue = new OrginalValue();
    private _input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
    private _visited: boolean = false;
    private _valid: boolean;

    constructor() {
        super();
    }

    public get initialValue() {
        return this._initialValue;
    }

    public set input(input: any) {
        this._input = input;
    }

    public get input() {
        return this._input;
    }

    public set visited(visited: boolean) {
        this._visited = visited;
    }

    public get visited() {
        return this._visited;
    }

    public genericBindEvents() {
        this._input.addEventListener("focus", (evt) => {
            this.visited = true;
            evt.preventDefault();
        });
    }

    public isEqualToInitialValue(value: any): boolean {
        let isEqual: boolean = true;

        const initialValue = this.initialValue.value;

        isEqual = (initialValue === value);

        return isEqual;
    }

    public set valid(valid: boolean) {
        this._valid = valid ?? true;
        if (this._valid) {
            this._input.classList.remove("has-error");
            this._input.classList.remove("is-pending");
            this.removeAttribute("data-tip");
        } else {
            if (this._visited) {
                this._input.classList.add("has-error");
                this._input.classList.remove("is-pending");
            } else {
                this._input.classList.add("is-pending");
            }
        }
    }

    public set validationMessage(message: string) {
        if (message != null) {
            this.setAttribute("data-tip", message);
        }
    }

    public focus() {
        this._input.focus();
    }

    abstract get data(): unknown;
    abstract set data(v: unknown);

    abstract set readOnly(ro: boolean);
}

export abstract class SelectHTMLElement extends BaseHTMLElement {

    constructor() {
        super();
    }

    public set readOnly(ro: boolean) {
        this.input.disabled = ro;
        if (ro) {
            this.input.classList.remove("c-select-input__input__enabled");
            this.input.classList.add("c-select-input__input__disabled");
        } else {
            this.input.classList.remove("c-select-input__input__disabled");
            this.input.classList.add("c-select-input__input__enabled")
        }
    }

}

export abstract class InputHTMLElement extends BaseHTMLElement {

    constructor() {
        super();
    }

    public addEventFocusin_selectContent() {
        this.input.addEventListener('focusin', (evt) => {
            let value = this.input.value;
            if (value && value.length > 0) {
                this.input.select();
            }
            evt.preventDefault();
        });
    }

    public isEqualForDate(actualValue: string | Date, initialValue: string | Date, granurality: moment.unitOfTime.StartOf) {
        let isEqual: boolean = true;

        if ((actualValue == null && initialValue != null) || (actualValue != null && initialValue == null)) {
            isEqual = false;
        } else if (actualValue != null && initialValue != null) {
            if (isDate(actualValue) || isDate(initialValue)) {
                isEqual = moment(actualValue).isSame(moment(initialValue), granurality)
            } else {
                isEqual = (initialValue === actualValue);
            }
        }

        return isEqual;
    }

    public isNumeric(str: any) {
        return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    public set readOnly(ro: boolean) {
        this.input.readOnly = ro;
    }
}

export class OrginalValue {

    private _initialized: boolean = false;
    private _value: any;

    public set value(value: any) {
        //if (!this._initialized) {
            this._value = value;
            this._initialized = true;
        //}
    }

    reassignvalue(value: any) {
        this._value = value;
    }

    public get value() {
        return this._value;
    }

    public get initialized() {
        return this._initialized;
    }
}
